export const privacyTexts = {
  ru: {
    title: "Политика конфиденциальности",
    eyebrow: "Правовая информация",
    link: "Политика конфиденциальности",
    linkInText: "Политике конфиденциальности",
    consentNote: "Отправляя форму, вы предоставляете данные для обработки вашего запроса. Подробнее — в",
    seoTitle: "Политика конфиденциальности — Tatiana Nakryzhskaya",
    seoDesc: "Политика конфиденциальности и обработки персональных данных сайта.",
    sections: [
      {
        h: "1. Кто обрабатывает данные",
        p: "Tatiana Nakryzhskaya, MD, PhD, CFMP — врач, Прага, Чехия. Это личный сайт врача, не юридического лица. Контакт по вопросам персональных данных: info@tatiananakryzhskaya.com.",
      },
      {
        h: "2. Какие данные собирает сайт",
        items: [
          "Форма «Написать мне»: имя, e-mail и текст сообщения. Сообщение пересылается на почту врача и сохраняется в защищённой базе данных сайта. Используется только для ответа на ваше обращение.",
          "Форма «Запись на консультацию»: имя, контакт (e-mail или телефон), тип консультации и текст сообщения. Сохраняются в базе данных сайта и видны только владельцу сайта в защищённой админ-панели.",
          "Запись на консультацию происходит через сторонние сервисы TopMedica (navstevalekare.cz) и Medevio (Институт функциональной медицины и питания). Данные, введённые там, обрабатываются этими сервисами по их собственным политикам конфиденциальности; этот сайт их не получает и не хранит.",
          "Сайт не собирает и не обрабатывает медицинские карты и данные о здоровье. Пожалуйста, не отправляйте медицинскую информацию через формы сайта.",
        ],
      },
      {
        h: "3. Аналитика (только с вашего согласия)",
        p: "Внутренняя статистика: просмотренная страница, язык, источник перехода, тип действия и время — без IP-адреса и cookies. Microsoft Clarity: записи сессий, тепловые карты, технические данные устройства; обработчик — Microsoft (в соответствии с её политикой конфиденциальности). Clarity включается только после вашего согласия; изменить выбор можно в любой момент через «Настройки cookies» внизу сайта. Рекламное отслеживание не используется.",
      },
      {
        h: "4. Cookies",
        p: "Необходимые: выбранный язык и ваш выбор в баннере cookies. Аналитические cookies Microsoft Clarity — только после согласия.",
      },
      {
        h: "5. Технические данные",
        p: "Хостинг-провайдер (Emergent) обрабатывает технические данные, необходимые для работы сайта (стандартные серверные журналы).",
      },
      {
        h: "6. Хранение и удаление",
        p: "Сообщения и персональные данные, предоставленные через формы обратной связи, хранятся в течение срока, необходимого для обработки и ответа на запрос. По достижении цели обработки данные удаляются в соответствии с установленными сроками хранения, если отсутствуют законные основания для их дальнейшего хранения. Запросы на удаление персональных данных можно направить на info@tatiananakryzhskaya.com.",
      },
      {
        h: "7. Ваши права (GDPR)",
        p: "Доступ к данным, исправление, удаление, ограничение обработки, возражение, отзыв согласия. Жалоба: Úřad pro ochranu osobních údajů (ÚOOÚ), Чехия.",
      },
    ],
  },
  cs: {
    title: "Zásady ochrany osobních údajů",
    eyebrow: "Právní informace",
    link: "Zásady ochrany osobních údajů",
    linkInText: "Zásadách ochrany osobních údajů",
    consentNote: "Odesláním formuláře poskytujete údaje pro zpracování vašeho dotazu. Podrobnosti v",
    seoTitle: "Zásady ochrany osobních údajů — Tatiana Nakryzhskaya",
    seoDesc: "Zásady ochrany a zpracování osobních údajů na tomto webu.",
    sections: [
      {
        h: "1. Správce údajů",
        p: "Tatiana Nakryzhskaya, MD, PhD, CFMP — lékařka, Praha, Česká republika. Jedná se o osobní web lékařky, nikoli o web právnické osoby. Kontakt pro dotazy k osobním údajům: info@tatiananakryzhskaya.com.",
      },
      {
        h: "2. Jaké údaje web shromažďuje",
        items: [
          "Formulář „Napsat mi“: jméno, e-mail a text zprávy. Zpráva je přeposlána na e-mail lékařky a uložena v zabezpečené databázi webu. Slouží výhradně k zodpovězení vašeho dotazu.",
          "Formulář „Objednání na konzultaci“: jméno, kontakt (e-mail nebo telefon), typ konzultace a text zprávy. Ukládají se v databázi webu a jsou viditelné pouze provozovateli webu v zabezpečené administraci.",
          "Objednání na konzultaci probíhá přes externí služby TopMedica (navstevalekare.cz) a Medevio (Institut funkční medicíny a výživy). Údaje zadané tam zpracovávají tyto služby podle svých vlastních zásad ochrany osobních údajů; tento web je nezískává ani neukládá.",
          "Web neshromažďuje lékařskou dokumentaci ani zdravotní údaje. Zdravotní informace prosím neposílejte prostřednictvím webových formulářů.",
        ],
      },
      {
        h: "3. Analytika (pouze s vaším souhlasem)",
        p: "Interní statistika: zobrazená stránka, jazyk, zdroj návštěvy, typ události a čas — bez IP adresy a cookies. Microsoft Clarity: nahrávky relací, mapy kliků, technické údaje zařízení; zpracovatelem je Microsoft (v souladu s jeho zásadami ochrany osobních údajů). Clarity se spouští pouze po vašem souhlasu; volbu lze kdykoli změnit přes „Nastavení cookies“ v patičce webu. Reklamní sledování se nepoužívá.",
      },
      {
        h: "4. Cookies",
        p: "Nezbytné: zvolený jazyk a vaše volba v cookie liště. Analytické cookies Microsoft Clarity — pouze po udělení souhlasu.",
      },
      {
        h: "5. Technické údaje",
        p: "Poskytovatel hostingu (Emergent) zpracovává technické údaje nezbytné k provozu webu (standardní serverové logy).",
      },
      {
        h: "6. Uchovávání a výmaz",
        p: "Zprávy a osobní údaje poskytnuté prostřednictvím kontaktních formulářů uchováváme po dobu nezbytnou pro jejich zpracování a zodpovězení dotazu. Po dosažení účelu zpracování jsou údaje vymazány v souladu se stanovenými lhůtami uchovávání, pokud neexistují zákonné důvody pro jejich další uchovávání. Žádosti o výmaz osobních údajů lze zasílat na info@tatiananakryzhskaya.com.",
      },
      {
        h: "7. Vaše práva (GDPR)",
        p: "Přístup k údajům, oprava, výmaz, omezení zpracování, námitka, odvolání souhlasu. Stížnost: Úřad pro ochranu osobních údajů (ÚOOÚ).",
      },
    ],
  },
  en: {
    title: "Privacy Policy",
    eyebrow: "Legal information",
    link: "Privacy Policy",
    linkInText: "Privacy Policy",
    consentNote: "By submitting the form, you provide your data for the processing of your enquiry. Details in the",
    seoTitle: "Privacy Policy — Tatiana Nakryzhskaya",
    seoDesc: "Privacy and personal data processing policy of this website.",
    sections: [
      {
        h: "1. Data controller",
        p: "Tatiana Nakryzhskaya, MD, PhD, CFMP — physician, Prague, Czech Republic. This is the personal website of a physician, not of a legal entity. Contact for personal data questions: info@tatiananakryzhskaya.com.",
      },
      {
        h: "2. What data this site collects",
        items: [
          "\u201CWrite to me\u201D form: your name, e-mail and message text. The message is forwarded to the physician's inbox and stored in the site's secured database. It is used solely to respond to your enquiry.",
          "\u201CBook a consultation\u201D form: name, contact (e-mail or phone), consultation type and message text. Stored in the site's database and visible only to the site owner in the secured admin panel.",
          "Appointment booking runs via the third-party services TopMedica (navstevalekare.cz) and Medevio (Institute of Functional Medicine and Nutrition). Data you enter there is processed by those services under their own privacy policies; this site neither receives nor stores it.",
          "This site does not collect or process medical records or health data. Please do not send medical information through the website forms.",
        ],
      },
      {
        h: "3. Analytics (only with your consent)",
        p: "Built-in statistics: page viewed, language, referral source, event type and time — no IP address, no cookies. Microsoft Clarity: session recordings, click heatmaps, device technical data; processed by Microsoft in accordance with its privacy policy. Clarity starts only after your consent; you can change your choice anytime via \u201CCookie settings\u201D in the site footer. No advertising tracking is used.",
      },
      {
        h: "4. Cookies",
        p: "Necessary: your chosen language and your cookie banner choice. Microsoft Clarity analytics cookies — only after consent.",
      },
      {
        h: "5. Technical data",
        p: "The hosting provider (Emergent) processes technical data required to operate the site (standard server logs).",
      },
      {
        h: "6. Retention and deletion",
        p: "Messages and personal data provided through the contact forms are retained for the period necessary to process and respond to your enquiry. Once the purpose of processing is achieved, the data is deleted in accordance with the established retention periods, unless lawful grounds for further retention exist. Requests for deletion of personal data can be sent to info@tatiananakryzhskaya.com.",
      },
      {
        h: "7. Your rights (GDPR)",
        p: "Access, rectification, erasure, restriction of processing, objection, withdrawal of consent. Complaints: Úřad pro ochranu osobních údajů (ÚOOÚ), Czech Republic.",
      },
    ],
  },
};
